module.exports = __webpack_public_path__ + "static/img/onlineShopBanner1.2b6a764.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/solution/onlineShopBanner1.png
// module id = oOtj
// module chunks = 1